export const COST_REPORT_CATEGORIES = {
    CHECK_IN: 'checkIn',
    CONDITION_REPORT: 'conditionReport',
    STORAGE: 'storage',
    WASH: 'wash',
    INSPECTION: 'inspection',
    MECHANICAL: 'mechanical',
    ADMINISTRATIVE: 'administrative',
    CHECK_OUT: 'checkOut',
};

// Categories shown as flat line items (no WO breakdown)
export const FLAT_CATEGORIES = [
    COST_REPORT_CATEGORIES.CHECK_IN,
    COST_REPORT_CATEGORIES.CONDITION_REPORT,
    COST_REPORT_CATEGORIES.STORAGE,
    COST_REPORT_CATEGORIES.CHECK_OUT,
];

// Categories shown with per-WO breakdown
export const WO_BREAKDOWN_CATEGORIES = [
    COST_REPORT_CATEGORIES.WASH,
    COST_REPORT_CATEGORIES.INSPECTION,
    COST_REPORT_CATEGORIES.MECHANICAL,
    COST_REPORT_CATEGORIES.ADMINISTRATIVE,
];

export const COST_REPORT_CATEGORY_LABELS = {
    [COST_REPORT_CATEGORIES.CHECK_IN]: 'Check In',
    [COST_REPORT_CATEGORIES.CONDITION_REPORT]: 'Condition Report',
    [COST_REPORT_CATEGORIES.STORAGE]: 'Storage',
    [COST_REPORT_CATEGORIES.WASH]: 'Wash',
    [COST_REPORT_CATEGORIES.INSPECTION]: 'Inspection',
    [COST_REPORT_CATEGORIES.MECHANICAL]: 'Mechanical',
    [COST_REPORT_CATEGORIES.ADMINISTRATIVE]: 'Administrative',
    [COST_REPORT_CATEGORIES.CHECK_OUT]: 'Check Out',
};

export const ALL_CATEGORIES = Object.values(COST_REPORT_CATEGORIES);

export const DATE_RANGE_PRESETS = {
    THIS_MONTH: 'thisMonth',
    LAST_MONTH: 'lastMonth',
    CUSTOM: 'custom',
};

export const DATE_RANGE_PRESET_LABELS = {
    [DATE_RANGE_PRESETS.THIS_MONTH]: 'This Month',
    [DATE_RANGE_PRESETS.LAST_MONTH]: 'Last Month',
    [DATE_RANGE_PRESETS.CUSTOM]: 'Custom',
};

export const LOCAL_STORAGE_CATEGORIES_KEY = 'pmf_cost_report_selected_categories';

// The API endpoints return a PDF blob directly (server-side via DraftReport + IHtmlToPdfConvertor).
// The server-side data model is defined in:
//   parqai-api/src/PMF.Application/Endpoint/Vehicle/CostReport/CostReportModel.cs
